module.exports = __webpack_public_path__ + "img/reorder-only-product.1168ddb.avif";